export default __webpack_public_path__ + "static/media/Project04.0c8b61ec.jpg";